<template>

  <el-row type="flex" justify="center" align="middle">

    <el-col :span="1" align="right">
      <el-button type="text" :disabled="!(pageCount > 1 && currentPage > 1)"
        @click="currentPage > 0 ? currentPage -= 1 : currentPage = 1">
        <i class="fa fa-caret-left"></i>
      </el-button>
    </el-col>

    <el-col :span="2" align="right">
      Page:&nbsp;
    </el-col>
    <el-col :span="3" align="center">
      <el-input-number
      v-model="currentPage"
      :min="1"
      :max="pageCount"
      size="mini" />
    </el-col>
    <el-col :span="2" align="left">
      &nbsp;/ <b>{{pageCount}}</b>
    </el-col>

    <el-col :span="1" align="center">
      <el-button :disabled="!(pageCount > 1 && currentPage < pageCount)"
        type="text" @click="currentPage < pageCount ? currentPage += 1 : currentPage = 1">
        <i class="fa fa-caret-right"></i>
      </el-button>
    </el-col>
</el-row>

</template>


<script>

export default {

  props: {
    value: {
      required: true
    },

    totalPages: {
      type: Number,
      required: true
    }
  },

  watch: {

    value: function (pg) {
      this.currentPage = pg
    },

    currentPage: function (pg) {
      this.currentPage = pg
      this.$emit('input', pg)
    },

    totalPages: function (tp) {
      this.pageCount = tp
    }

  },

  data () {
    return {
      currentPage: this.value,
      pageCount: this.totalPages
    }
  }
}
</script>



// WEBPACK FOOTER //
// PdfToolbar.vue?7ead02f4